import React from 'react';
import { InfoOutlined, Close, Warning } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import {
	WarningBarContainer,
	IconContainer,
	MessageText,
	CloseButtonContainer,
} from './WarningBar.styles';

export type WarningBarVariant = 'info' | 'warning';

interface WarningBarProps {
	show: boolean;
	message: string;
	variant?: WarningBarVariant;
	onClose?: () => void;
}

export const WarningBar = ({
	show,
	message,
	variant = 'warning',
	onClose,
}: WarningBarProps) => {
	if (!show) {
		return null;
	}

	const isInfo = variant === 'info';

	return (
		<WarningBarContainer variant={variant}>
			<IconContainer variant={variant}>
				{isInfo ? (
					<InfoOutlined sx={{ fontSize: '24px', color: 'white' }} />
				) : (
					<Warning sx={{ fontSize: '24px', color: 'white' }} />
				)}
			</IconContainer>
			<MessageText variant={variant}>{message}</MessageText>
			{onClose && (
				<CloseButtonContainer>
					<IconButton
						size="small"
						onClick={onClose}
						sx={{
							padding: '4px',
							'&:hover': {
								backgroundColor: 'transparent',
							},
						}}
						aria-label="Close">
						<Close sx={{ fontSize: '16px' }} />
					</IconButton>
				</CloseButtonContainer>
			)}
		</WarningBarContainer>
	);
};
